import { render, staticRenderFns } from "./EditPromotionRule.vue?vue&type=template&id=750113b0&"
import script from "./EditPromotionRule.vue?vue&type=script&lang=js&"
export * from "./EditPromotionRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports